import { Component } from "react";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { message } from "antd";
import { Button } from "react-bootstrap";
import { HeaderTwoLogo } from "../../../assets/images";
import "./download-print.css";
import { backImage } from "../../../assets/images";
import { QRCodeSVG } from "qrcode.react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default class DownloadTravelCertificate extends Component {
  constructor(props) {
    super(props);
   const params = new URLSearchParams(window.location.search);

  const id = params.get("id");
    this.state = {
      isLoading: false,
      certificate_details: {},
      userDetails: {},
      certificateChangeLogo: "",
      previewImage: "",
      logoVisible: true,
      referCode: "",
      clientDetails: {},
      clientDetailsSupportEmail:null,
      id:id
    };
  }

  componentDidMount = () => {
    let userDetails = localStorage.getItem("userDetails");

    userDetails = userDetails ? JSON.parse(userDetails) : {};
    this.setState({ userDetails });
    this.setState({ previewImage: HeaderTwoLogo });
    if (userDetails.certificateOwnLogo) {
      this.setState({ previewImage: userDetails.certificateOwnLogo });
    }

    const clientDetails = JSON.parse(localStorage.getItem("clientDetails"));
    this.setState({ clientDetails });

    this.getCertificateDetails();
    this.getUserAffiliteDetails(userDetails.id);
  };

  gotoBack = () => {
    window.location.href = "/print";
  };

  getCertificateDetails = () => {
    this.setState({ isLoading: true });
    axios
      .get(`/get-travel-certificate/${this.state.id}`)
      .then((res) => {
        if (res.data.status) {
          this.setState({ certificate_details: res.data.certificate_details });
          setTimeout(() => {
            this.setState({ isLoading: false });
            setTimeout(() => {
              //this.printDocument();
            }, 1000);
          }, 5000);
        } else {
          this.setState({ isLoading: false });
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });
        message.error("Something went wrong");
      });
  };

  getUserAffiliteDetails = (id) => {
    this.setState({ isLoading: true });
    axios
      .get(`/user/get-user-id-by-affiliate-details/${id}`)
      .then((res) => {
        // this.setState({ isLoading: false });
        let urlByCode = res.data.data.url.substring(
          res.data.data.url.lastIndexOf("/") + 1,
        );
        this.setState({ referCode: urlByCode });
        if(res.data?.clientDetailsSupportEmail){
          this.setState({clientDetailsSupportEmail:res.data.clientDetailsSupportEmail});
        }
      })
      .catch((err) => {
        console.error(err);
        // this.setState({ isLoading: false });
        message.error("Something went wrong");
      });
  };

  printDocument = () => {
    let printContents = document.getElementById("print_content").innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    window.close();
  };

  logoUpload = async (e) => {
    e.preventDefault();
    if (this.state.certificateChangeLogo != "") {
      this.setState({ isLoading: true });
      let data = new FormData();
      data.append("logo", this.state.certificateChangeLogo);
      data.append("userId", this.state.userDetails.id);
      data.append("source", this.state.userDetails.source);

      await axios
        .post(`/certificate-user-wise-logo`, data)
        .then((res) => {
          console.log(res);
          this.setState({ isLoading: false });
          if (res.data.status === true) {
            document.getElementById("logo-upload-form").reset();
            message.success(res.data.message);
            let uDetails = localStorage.setItem(
              "userDetails",
              JSON.stringify(res.data.data),
            );
            uDetails = JSON.parse(uDetails);
            this.setState({ userDetails: uDetails });
          } else {
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          console.log(err);
        });
    } else {
      message.error("Please upload your logo!");
    }
  };

  removeLogo = (e) => {
    document.getElementById("logo-upload-form").reset();
    this.setState({ logoVisible: false });
    message.success("Logo remove successfully!");
  };
  render() {
    let { userDetails, certificate_details } = this.state;

    return (
      <LoadingOverlay spinner active={this.state.isLoading} text="Loading...">
        <div className="row form-box">
          <div className="col-md-12">
            <Button
              variant="primary"
              className="float-left"
              type="button"
              onClick={() => {
                this.gotoBack();
              }}
            >
              <img src={backImage} style={{ width: "20px" }} alt="" srcset="" />{" "}
              Back
            </Button>
            <Button
              variant="primary"
              className="float-right"
              type="button"
              onClick={() => {
                this.printDocument();
              }}
            >
              Print
            </Button>
          </div>
        </div>

        <div className="pdf_inner_inner_box1" id="print_content">
          <div className="pdf_boxi1">
            <div className="create_pdfff1">
              <table
                className="pdf_content"
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                role="presentation"
                style={{
                  backgroundColor: "#fff",
                  color: "#000000",
                  width: "100%",
                  margin: "0",
                }}
              >
                <tr>
                  <td style={{ paddingBottom: "30px" }}>
                    <div className="pdf_banner">
                      <img
                        src={certificate_details.banner}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "340px",
                          objectFit: "cover",
                        }}
                        alt="Travel Certificate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table
                      align="center"
                      border="0"
                      cellpadding="0"
                      cellspacing="0"
                      style={{
                        backgroundColor: "#fff",
                        width: "100%",
                        color: "#000000",
                      }}
                    >
                      <tr>
                        <td
                          lg="3"
                          md="4"
                          sm="12"
                          valign="top"
                          className="padding_top30px"
                          style={{ padding: "8px 15px", width: "200px" }}
                        >
                          <div
                            className="pdf_price_img"
                            tyle={{ marginBottom: "20px" }}
                          >
                            <img
                              src={certificate_details.pricetag}
                              className="img-fluid"
                              style={{ maxWidth: "100%" }}
                              alt="Price Tag"
                            />
                          </div>
                          <div
                            className="scan_code code_scan"
                            style={{ marginBottom: "20px" }}
                          >
                            <QRCodeSVG
                              className="img-fluid"
                              style={{ maxWidth: "100%" }}
                              value={`https://redeem.viptravelreward.com/${this.state.referCode}/${certificate_details.certificate_code}/${userDetails?._id}`}
                            />
                          </div>
                          {this.state.logoVisible ? (
                            <>
                              <div className="pdf_logo_img logo_pdf">
                                <img
                                  src={
                                    this.state.clientDetails.corporateClientLogo
                                  }
                                  className="img-fluid"
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "200px",
                                    objectFit: "contain",
                                  }}
                                  alt="Logo"
                                />
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td
                          lg="9"
                          md="8"
                          sm="12"
                          valign="top"
                          style={{ padding: "8px 15px", paddingRight: "20px" }}
                        >
                          <div className="certificate_terms inner_termmmms">
                            <h2>Terms of the Certificate</h2>
                            <div
                              className="text-justify"
                              dangerouslySetInnerHTML={{
                                __html:
                                  certificate_details.certificate_description,
                              }}
                            />

                            <h3>GET YOUR CERTIFICATE TODAY!</h3>
                            <div className="go_online online_go">
                              <p>Go Online:<a href={`https://redeem.viptravelreward.com/${this.state.referCode}`} target="_blank" rel="noopener noreferrer"> https://redeem.viptravelreward.com/{this.state.referCode}</a></p>
                              {/* <p>Enter Referral Code: {userDetails?.name}</p> */}
                              <p>Enter Referral Code: {this.state.referCode}</p>
                              <p>
                                Certificate Code:
                                {certificate_details.certificate_code}
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "8px 15px" }}>
                    <div className="foot_cont" style={{ textAlign: "center" }}>
                      <p>
                        If you have general questions about your certificate
                        please email <a href={`mailto:${this.state.clientDetailsSupportEmail || 'support@tripvalet.com'}`}>{this.state.clientDetailsSupportEmail || 'support@tripvalet.com'}</a> Monday to
                        Friday from 9am to 5pm Central Time.
                      </p>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}
